import { FC, useState } from "react";
import {
    Box,
    Flex,
    Heading,
    useBreakpointValue,
    Picture,
} from "@smile2impress/components/relaunch";
import { UniversalTextElement } from "templates/relaunch/primitives/UniversalTextElement";

import { ColumnProps } from "./Column.types";

export const Column: FC<ColumnProps> = ({
    title,
    text,
    image,
    withExpandableText = false,
    numberHeading,
}) => {
    const isMobile = useBreakpointValue({
        base: true,
        tablet: true,
        desktop: false,
    });
    const [localTextExpanded, setTextExpanded] = useState(!isMobile);
    const toggleTextExpanded = () => {
        setTextExpanded((prev) => !prev);
    };
    return (
        <Flex
            direction={["column-reverse", "column-reverse", "row"]}
            justifyContent="space-between"
            gap={[2, 2, 0]}
        >
            <Flex
                basis={["auto", "auto", "42%"]}
                direction={["row", "row", "column"]}
                justifyContent="flex-start"
                mr={[0, 0, 2]}
            >
                {numberHeading && (
                    <Heading
                        textStyle={"title2"}
                        color="text.primary"
                        mb={[0, 0, 1]}
                        mr={[2, 2, 0]}
                        alignSelf="flex-start"
                        as="h3"
                    >
                        {numberHeading}
                    </Heading>
                )}
                <Flex w="100%">
                    <UniversalTextElement
                        title={title}
                        text={text}
                        withSeparator={[true, true, false]}
                        withExpandableText={withExpandableText}
                        extraTitleStyles={{
                            textStyle: "title2",
                            textTransform: "none",
                            as: "h3",
                        }}
                        textExpanded={localTextExpanded}
                    />
                </Flex>
            </Flex>
            <Flex basis={["auto", "auto", "42%"]} onClick={toggleTextExpanded}>
                <Box
                    overflow="hidden"
                    borderRadius={"sm"}
                    w="100%"
                    h={["204px", "204px", "316px"]}
                    bg="bg.grey"
                >
                    <Picture {...image} imageProps={{ h: ["100%"] }} />
                </Box>
            </Flex>
        </Flex>
    );
};
